/* eslint-disable no-restricted-imports */
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { isDefined } from "@clipboard-health/util-ts";
import { useSelector } from "react-redux";
import { DeprecatedReduxState } from "@src/appV2/ExperimentalHomeHealth/lib/types";
import { useEffect } from "react";

export function useIsStreaksPreRewardsEnabled() {
  // TODO: https://linear.app/clipboardhealth/issue/CS-2908/centralize-launch-darkly-context-setting-in-the-hcf-admin-webapp
  // The work in the ticket above will let us move away from using the selector below.
  const profile = useSelector((state: DeprecatedReduxState) => state.session?.profile);
  const ldClient = useLDClient();

  useEffect(() => {
    if (isDefined(profile) && isDefined(ldClient)) {
      ldClient.identify({
        ...ldClient.getContext(),
        pricingMsa: profile.pricingMsa,
      });
    }
  }, [ldClient, profile]);

  return useCbhFlag(CbhFeatureFlag.STREAKS_PRE_REWARD, {
    defaultValue: false,
  });
}
